export var TrackingModule = (function() {
    var siteId;
    var trackingConfig;
    var trackingScriptsLoaded = false;
    var eventQueue = [];

    function init(config) {
        siteId = config.siteId;
        trackingConfig = config.trackingConfig || {};
        loadTrackingScripts(function() {
            trackingScriptsLoaded = true;
            eventQueue.forEach(function(event) {
                sendEvent(event.name, event.data);
            });
            eventQueue = [];
        });
    }

    function loadTrackingScripts(callback) {

    }

    function trackEvent(eventName, data) {
        if (trackingScriptsLoaded) {
            sendEvent(eventName, data);
        } else {
            eventQueue.push({ name: eventName, data: data });
        }
    }

    function trackCartEvent(eventName, cart) {
        if (trackingScriptsLoaded) {
            sendEvent(eventName, cart);
        } else {
            eventQueue.push({ name: eventName, data: cart });
        }
    }

    function trackProductEvent(eventName, product) {
        if (trackingScriptsLoaded) {
            sendEvent(eventName, product);
        } else {
            eventQueue.push({ name: eventName, data: product });
        }
    }

    function sendEvent(eventName, data) {
        if (siteId === 'siteA') {
            if (window.ga) {
                window.ga('send', 'event', 'Werbemittel', eventName, JSON.stringify(data));
            }
        } else if (siteId === 'siteB') {
            if (window.siteBTracker) {
                window.siteBTracker.sendEvent(eventName, data);
            }
        }
        if (typeof _paq !== 'undefined') {
            _paq.push(['trackEvent', 'Shopify', 'Checkout from Cart', component.cart.id]);
        }
    }

    return {
        init: init,
        trackEvent: trackEvent
    };
})();
